var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var WebpushButton_1;
import { customElement, property, css, html, LitElement } from 'lit-element';
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["MARKETING"] = "1";
    SubscriptionType["PRODUCT_AVAILABLE"] = "2";
    SubscriptionType["ORDER_STATUS"] = "3";
})(SubscriptionType || (SubscriptionType = {}));
let WebpushButton = WebpushButton_1 = class WebpushButton extends LitElement {
    constructor() {
        super(...arguments);
        this.subscribeText = 'subscribe';
        this.subscribedText = 'subscribed';
        this.subscriptionType = SubscriptionType.MARKETING;
        this.subscriptionDetails = '{}';
        this.active = false;
        this.unsupported = true;
    }
    static get styles() {
        return css `
            .container {
                display: flex;
                align-items: center;
                margin: 0.5em 0;
                cursor: pointer;
                user-select: none;

                border: 1px solid var(--color-secondary);
                border-radius: 0.5em;
                padding: 0.5em;
            }
            .container.active {
                cursor: initial;
                border: 1px solid var(--color-primary);
            }
            .container.hidden {
                display: none;
            }
            .container svg {
                margin-right: 0.5em;
                fill: transparent;
                stroke: var(--color-secondary);
                transition:
                    fill 0.3s ease-out,
                    stroke 0.3s ease-out;
            }
            .container:not(.active):hover {
                text-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
            }
            .container:hover svg {
                fill: var(--color-secondary);
            }
            .container.active svg {
                fill: var(--color-primary);
                stroke: var(--color-primary);
            }
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        if ('serviceWorker' in navigator && 'PushManager' in window) {
            this.unsupported = false;
        }
        // Rejestracja service workera wymaganego do obsługi WebPushy
        if (!WebpushButton_1.initialized) {
            WebpushButton_1.initialized = true;
            navigator.serviceWorker
                .register('/service-worker.js', { scope: '/' })
                .then((registration) => {
                this.initSubscription(registration);
            })
                .catch(() => {
                this.unsupported = false;
            });
        }
    }
    render() {
        return html ` <div
            class="container ${this.active ? 'active' : ''} ${this.unsupported ? 'hidden' : ''}"
            @click=${(e) => {
            e.preventDefault();
            this.toggleState();
        }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--color-secondary)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-bell"
            >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
            <span>${this.active ? this.subscribedText : this.subscribeText}</span>
        </div>`;
    }
    toggleState() {
        if (this.unsupported || WebpushButton_1.registration === null) {
            return;
        }
        // Nie obsługujemy zmiany stanu na OFF
        if (this.active) {
            return;
        }
        // Klient nie subskrybuje powiadomień, musimy go najpierw do nich zapisać
        WebpushButton_1.registration.pushManager
            .subscribe({
            userVisibleOnly: true,
            applicationServerKey: this.urlBase64ToUint8Array(this.serverKey),
        })
            .then((subscription) => {
            WebpushButton_1.subscription = subscription;
            this.storeSubscription(subscription);
        })
            .catch((err) => {
            console.error('Failed to subscribe the user: ', err);
        });
    }
    storeSubscription(subscription) {
        fetch('/webpush/subscribe', {
            method: 'POST',
            body: JSON.stringify({
                endpoint: subscription.endpoint,
                client_public_key: this.arrayBufferToBase64(subscription.getKey('p256dh')),
                client_auth_key: this.arrayBufferToBase64(subscription.getKey('auth')),
                subscription_type: this.subscriptionType,
                subscription_details: this.details,
            }),
        })
            .then((res) => {
            if (!res.ok) {
                throw new Error('Invalid request');
            }
            this.active = true;
        })
            .catch((err) => {
            console.error('Failed to store subscription', err);
        });
    }
    initSubscription(registration) {
        WebpushButton_1.registration = registration;
        registration.pushManager
            .getSubscription()
            .then((subscription) => {
            WebpushButton_1.subscription = subscription;
        })
            .catch((err) => {
            console.error('Failed to initialize subscription', err);
        });
    }
    get serverKey() {
        if (typeof window.__WEBPUSH__ === 'undefined') {
            return '';
        }
        return window.__WEBPUSH__.publicKey;
    }
    get details() {
        try {
            return JSON.parse(this.subscriptionDetails);
        }
        catch (err) {
            console.error('Failed to parse subscription details', err);
            return {};
        }
    }
    urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }
    arrayBufferToBase64(buffer) {
        if (buffer === null) {
            return '';
        }
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
};
WebpushButton.initialized = false;
WebpushButton.registration = null;
WebpushButton.subscription = null;
__decorate([
    property({ type: String })
], WebpushButton.prototype, "subscribeText", void 0);
__decorate([
    property({ type: String })
], WebpushButton.prototype, "subscribedText", void 0);
__decorate([
    property({ type: String })
], WebpushButton.prototype, "subscriptionType", void 0);
__decorate([
    property({ type: String })
], WebpushButton.prototype, "subscriptionDetails", void 0);
__decorate([
    property({ type: Boolean })
], WebpushButton.prototype, "active", void 0);
__decorate([
    property({ type: Boolean })
], WebpushButton.prototype, "unsupported", void 0);
WebpushButton = WebpushButton_1 = __decorate([
    customElement('webpush-button')
], WebpushButton);
export default WebpushButton;
